<template>
  <div class="animated fadeIn purchaseOrders--purchaseOrders-list">
    <fixed-header :title="getTitle">
      <template v-slot:center>
        <b-button size="sm"  to="/billpayments" variant="primary"><i class="fa fa-list"></i> Bill Payments</b-button>
      </template>
    </fixed-header>
    <div style="margin-top: 41px;" class="card">
      <div class="card-body">
        <div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Vendor" class="mt-1 mr-2">
            <b-input-group size="sm">
              <vue-simple-suggest
                id="requirement-vendor"
                class="suggest-input form-control"
                :class="{ 'is-invalid': ($v.header[payFields.COMPANY_ID].$required || !chosenName) }"
                :styles="autoCompleteStyle"
                :list="getListOfNames"
                :max-suggestions="20"
                :min-length="3"
                :debounce="200"
                v-model="chosenName"
                :filter-by-query="true"
                value-attribute="id"
                display-attribute="name"
                @select="onSuggestNameSelect"
                @input="onSuggestNameChange"
                @request-done="onRequestDone"
                autocomplete="off"
              >
                <div slot="misc-item-below" v-if="isLoading" class="misc-item">
                  <span>Loading Vendors...</span>
                </div>
              </vue-simple-suggest>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Payment Date" style="grid-column: 1; grid-row: 1;" class="mt-1 mr-2 required">
            <date-picker v-model="header[payFields.PAYMENT_DATE]" :config="datePickerOptions" :class="{ 'is-invalid': $v.header[payFields.PAYMENT_DATE].$error }"></date-picker>
          </b-form-group>
          <b-form-group label="Payment Method" class="mr-2 required">
            <b-form-select v-model="header[payFields.PAYMENT_METHOD_ID]" :class="{ 'is-invalid': $v.header[payFields.PAYMENT_METHOD_ID].$error }" @change="header[payFields.PAYMENT_ACCOUNT_ID] = null">
              <option
                v-for="option in sortSelect(paymentOptions)"
                :key="option.name"
                :value="option.id"
              >{{option.name}}</option>
            </b-form-select>
            </b-form-group>
          <b-form-group label="Account" class="mr-2 required">
            <b-form-select v-model="header[payFields.PAYMENT_ACCOUNT_ID]">
              <option :value="null"></option>
              <option
                v-for="option in sortSelect(paymentAccounts, 'accountName')"
                :key="option.name"
                :value="option.id"
              >{{option.accountName}}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Reference Number" class="mr-2">
            <b-form-input v-model="header[payFields.REFERENCE_NUMBER]" />
            </b-form-group>
          <b-form-group label="Amount Paid" class="mr-2" :class="totalVendorCredit > 0 ? '' : 'required'">
            <b-form-input
              type="number"
              v-model="header[payFields.AMOUNT]"
              @change="onPaidAmount"
              :class="{ 'is-invalid': $v.header[payFields.AMOUNT].$error }"
            />
          </b-form-group>
        </div>
        <b-row v-if="totalVendorCredit > 0">
          <b-col>
            <h6 style="color: red">NOTE: We have a ${{ totalVendorCredit }} credit for this vendor. This will be used on posting the payment.</h6>
          </b-col>
        </b-row>
        <Grid
          class="grid"
          :resizable="false"
          :reorderable="false"
          :sortable="false"
          :row-height="25"
          selected-field="selected"
          :data-items="itemData"
          :columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
        >
          <template v-slot:selectCommandsHeader="{}">
            <div class="d-flex justify-content-center">
              <grid-settings :gridId="gridId" :fields="fields" class="mr-2" />
            </div>
          </template>
          <template v-slot:selectcommands="{props}">
            <td>
              <div class="d-flex justify-content-center align-items-center">
                <input
                  type="checkbox"
                  v-model="checkedRowItemIdsArr[props.dataItem.index].selected"
                  @change="onSetCheckedRowItemIdsObjArr($event, props)"
                />
              </div>
            </td>
          </template>
          <template v-slot:navigation="{props}">
            <td>
              <div class="d-flex justify-content-center align-items-center">
                <a class="grid-link">{{ props.dataItem.id }}</a>
              </div>
            </td>
          </template>
          <template v-slot:editamount="{props}">
            <td>
              <div class="d-flex justify-content-center align-items-center">
                <input
                  type="number"
                  class="amountTextBox"
                  v-model="checkedRowItemIdsArr[props.dataItem.index].amount"
                  @change="onSetAmount($event, props.dataItem)"
                />
              </div>
            </td>
          </template>
          <template v-slot:total="{props}">
            <td>
              {{ Number(props.dataItem.total).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }) }}
            </td>
          </template>
          <template v-slot:balance="{props}">
            <td>
              {{ Number(props.dataItem.balance).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }) }}
            </td>
          </template>
           <template v-slot:soDate="{props}">
            <td>{{ props.dataItem.soDate | date }}</td>
          </template>
          <template v-slot:poDate="{props}">
            <td>{{ props.dataItem.poDate | date }}</td>
          </template>
          <template v-slot:dueDate="{props}">
            <td>{{ props.dataItem.dueDate | date }}</td>
          </template>
        </Grid>
        <b-card style="max-width: 80rem;" class=" mt-2">
          <b-card-text>
            <b-row>
              <b-col>
                <b-form-group label="Internal Comments">
                  <b-textarea v-model="header[payFields.COMMENTS]"/>
                </b-form-group>
              </b-col>
              <b-col>
                <div>
                  <span>Amount Available:</span>&nbsp;
                  <b>{{ Number(totalCredit).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }) }}</b>
                </div>
                <div>
                  <span>Amount Applied:</span>&nbsp;
                  <b>{{ Number(totalPayment).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }) }}</b>
                </div>
                <div class="buttons-panel m-1">
                  <b-button @click="onClear" size="sm" variant="secondary">Clear Payment</b-button>
                  <b-button @click="onSubmitPayment" size="sm" variant="primary" :disabled="isSaving">
                    <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Post Payment</b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { debounce } from 'lodash';
import FixedHeader from '@/shared/components/FixedHeader/index';
import { dateTime, date } from '@/shared/filters';
import {
  GRID_ID,
  DATE_FORMAT,
  AUTO_COMPLETE_STYLES,
  VENDOR_ID  
} from '@/shared/constants';
import {  prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import {PoDefaultFields as gridFields} from '../../fields';
import VueSimpleSuggest from 'vue-simple-suggest';
import { FIELDS as PAYMENT_FIELDS } from '../../constants';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { ACCOUNT_TYPES } from '@/pages/Accounting/components/ChartsOfAccounts/constants';

export default {
  components: {
    FixedHeader,
    GridSettings,
    VueSimpleSuggest,
  },
  props: {
    test: {
      type: String,
      default: 'default test',
    },
  },
  metaInfo: () => ({
    title: 'Add Bill Payments',
  }),
  data() {
    return {
      date,
      prepareColumnsData,
      totalPayment: 0,
      totalCredit: 0,
      fields: gridFields,
      gridId: GRID_ID.POST_PAYMENTS,
      checkedRowItemIdsArr: [],
      paymentOptions: [
        { id: null, name: '' },
        { id: 339, name: 'Cash' },
        { id: 340, name: 'Check' },
        { id: 341, name: 'Credit Card' },
        { id: 342, name: 'ACH' },
        { id: 343, name: 'Wire' },
      ],
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      chosenName: '',
      isLoading: false,
      payFields: PAYMENT_FIELDS,
      header: {
        paymentDate: new Date(),
      },
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: true,
      },
      sourceId: this.$route.params.sourceId || 1,
      isSaving: false,
      bankAccounts: [],
      ccAccounts: [],
      companyCredits: []
    };
  },
  validations: {
    header: {
      [PAYMENT_FIELDS.PAYMENT_DATE]:  { required },
      [PAYMENT_FIELDS.COMPANY_ID]: { required },
      [PAYMENT_FIELDS.PAYMENT_METHOD_ID]: { required },
      [PAYMENT_FIELDS.PAYMENT_ACCOUNT_ID]: { required },
      [PAYMENT_FIELDS.AMOUNT]: { required: requiredIf(function() { return this.totalVendorCredit == 0; }) },
    },
  },
  computed: {
    ...mapGetters('billPayments', [
      'purchaseOrders',
      'selectedCompanyId',
      'selectedCompanyName',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('quickBooks', ['qboSettingState']),
    getTitle(){
      return `Add Bill Payments ${(this.sourceId==2)?'(Service':'(Purchase'} Order)`;
    },
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.selectedCompanyId > 0) {
      this.checkedRowItemIdsArr = this.purchaseOrders.map((purchaseOrder, index) => ({
        ...purchaseOrder,
        amount: '',
        index,
        selected: false,
      }));
      return this.checkedRowItemIdsArr;
      }
    },
    paymentAccounts() {
      return this.header[this.payFields.PAYMENT_METHOD_ID] == 341 ? this.ccAccounts : this.bankAccounts;
    },
    totalVendorCredit() {
      return this.companyCredits.length > 0 ? this.companyCredits.map(details => details.balance).reduce((a, b) => a + b) : 0;
    }
  },
  filters: {
    dateTime,
    date,
  },
  methods: {
    ...mapActions('billPayments', [
      'getAllPoSo',
      'selectCompany',
      'setCheckedRowItemIdsObjArr',
      'create',
    ]),
    ...mapActions('purchaseorders', { poMultiSaveToQbo: 'multiSaveToQuickbooks' }),
    ...mapActions('serviceOrders', { woMultiSaveToQbo: 'multiSaveToQuickbooks' }),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('companies', ['getByNameAndAccountType']),
    ...mapActions('expenses', ['getChartOfAccounts']),
    ...mapActions('quickBooks', ['getQboSettingState']),
    ...mapActions('creditMemos', ['syncAllToQuickbooks', 'getCreditsByCompany']),      
    onClear() {
      //clear selected rows and balance
      this.checkedRowItemIdsArr = [];
      this.companyCredits = [];
      this.totalCredit = this.totalPayment = 0;
      this.header[PAYMENT_FIELDS.AMOUNT] = '';
      this.header[PAYMENT_FIELDS.PAYMENT_DATE] = new Date()
    },
    onPaidAmount() {
      let receivedAmount = parseInt(this.header[PAYMENT_FIELDS.AMOUNT] || 0) + this.totalVendorCredit;
      this.totalCredit = this.totalPayment = 0;
      //if balance then
      if (receivedAmount > 0) {
        //check each selected row balance and calculate total payment and credit payment
        this.checkedRowItemIdsArr.map((data, index) => {
          if (receivedAmount > 0) {
            //if remaining received amount is morethan current row total then
            if (receivedAmount >= this.checkedRowItemIdsArr[index].balance) {
              //set amount and checkbox as checked also revise received payment means deduct row total from received balance
              this.checkedRowItemIdsArr[index].amount = this.checkedRowItemIdsArr[index].balance;
              this.checkedRowItemIdsArr[index].selected = true;
              receivedAmount = receivedAmount - this.checkedRowItemIdsArr[index].balance;
              this.totalPayment += parseInt(this.checkedRowItemIdsArr[index].balance);
            } else {
            //if received amount is less than total then set receive amount into textbox
              this.checkedRowItemIdsArr[index].amount = receivedAmount;
              this.checkedRowItemIdsArr[index].selected = true;
              this.totalPayment += parseInt(receivedAmount);
              receivedAmount = 0;
            }
          } else {
            //once received balance become zero then uncheck other rows
            this.checkedRowItemIdsArr[index].amount = '';
            this.checkedRowItemIdsArr[index].selected = false;
          }
        });
        this.updateBalance()
      } else {
        this.onClear();
      }
    },
    onSubmitPayment() {
      //check validations
       this.$v.header.$touch();
        if (this.$v.header.$invalid ) {
         return;
        }
      let lines = [];
      //prepare form data to post
      let formData = {
        id: 0,
        companyId: this.selectedCompanyId,
        paymentDate:
          this.header[PAYMENT_FIELDS.PAYMENT_DATE] != ''
            ? new Date(this.header[PAYMENT_FIELDS.PAYMENT_DATE]).toISOString()
            : '',
        paymentMethodId: this.header[PAYMENT_FIELDS.PAYMENT_METHOD_ID],
        paymentAccountId: this.header[PAYMENT_FIELDS.PAYMENT_ACCOUNT_ID],
        referenceNumber: this.header[PAYMENT_FIELDS.REFERENCE_NUMBER],
        amount: this.header[PAYMENT_FIELDS.AMOUNT] || 0,
        comments: this.header[PAYMENT_FIELDS.COMMENTS],
        sourceId: this.sourceId,
        active: true,
      };
      //map seledted rows data into form data object
      this.checkedRowItemIdsArr.map(data => {
        if (data.selected) {
          lines.push({
            id: 0,
            billPaymentId: 0,
            //purchaseOrderId: data.id,
            referenceId: data.id,
            amount: data.amount,
            balance: data.balance,
            active: true,
          });
        }
      });
      
      try {
        this.isSaving = true;
        formData.lines = lines;
        //call set payment API
        this.create(formData).then((result) => {
          //after success response from server clear all datas
          this.header = {}
          this.chosenName = ''
          this.selectCompany({});
          this.$v.$reset()
          this.$v.header.$reset();
          if (result)
            this.syncToQuickbooks(this.checkedRowItemIdsArr.filter(x => x.selected && x.amount > 0).map(x => x.id));
          this.onClear()
          this.isSaving = false;
        });
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
      
    },
    
    async syncToQuickbooks(ids) {
      if (ids.length > 0) {
        let qboActiveState = false;
      
        await this.getQboSettingState().then(() => {
          qboActiveState = this.qboSettingState != null && this.qboSettingState.value ? this.qboSettingState.value == '1' : false;
        });

        if (qboActiveState) {
          this.$snotify.info("Syncing to Quickbooks...");
          if (this.sourceId == 1)
            await this.poMultiSaveToQbo(ids)
          else if (this.sourceId == 2)
            await this.woMultiSaveToQbo(ids);
          await this.syncAllToQuickbooks();
        }  
      }

    },
    async getListOfNames(name) {
      return await this.getByNameAndAccountType({
        typeId: VENDOR_ID,
        name,
      });
    },
    async onSuggestNameSelect(suggestion) {
      this.selectedAccount = suggestion;
      this.header[PAYMENT_FIELDS.COMPANY_ID] = suggestion.id;
      this.companyCredits = [];
      this.getCreditsByCompany(suggestion.id).then((result) => this.companyCredits = result);
      await this.selectCompany(suggestion);
      await this.getAllPoSo(this.sourceId);
      this.onPaidAmount()
    },
    async onSuggestNameChange() {
      this.isLoading = true;
      //if textbox is clear then remove data from state
      if (this.chosenName === ''){
        this.selectCompany({});
        this.header[PAYMENT_FIELDS.COMPANY_ID] = null;
      }else if (this.chosenName !== this.selectedCompanyName) {
        //if textbox name is change with state name then also clear id from state
        this.selectCompany({});
        this.header[PAYMENT_FIELDS.COMPANY_ID] = null;
        this.$v.header[PAYMENT_FIELDS.COMPANY_ID].$touch();
      }
    },
    onRequestDone() {
      this.isLoading = false;
    },
    onSetCheckedRowItemIdsObjArr(value, data) {
      let amount = parseInt(this.header[PAYMENT_FIELDS.AMOUNT]) + this.totalVendorCredit;
      
      if (!value.target.checked) {
        //if checkbox is unchecked then clear amount
        this.checkedRowItemIdsArr[data.dataItem.index].amount = '';
      }else if(parseInt(this.totalPayment+data.dataItem.balance)<=amount){
        //if selected rows total is lessthan received amount then allow
        this.checkedRowItemIdsArr[data.dataItem.index].amount = data.dataItem.balance
      }else if(parseInt(this.totalPayment+data.dataItem.balance)>amount && this.totalCredit>0){
        //if selected row balance is greaterthan  received balance then allow only remaining balance
        let remaining = parseInt(amount -this.totalPayment)
        this.checkedRowItemIdsArr[data.dataItem.index].amount = remaining;
      }else{
        //if total credit is not availale then dont allow value
        value.target.checked=false;
        this.checkedRowItemIdsArr[data.dataItem.index].selected = false;
        this.checkedRowItemIdsArr[data.dataItem.index].amount = '';
      }
      this.updateBalance();
    },
    onSetAmount(value, data) {
      //when amount is enter into textbox then make checkbox selected
      if (!this.checkedRowItemIdsArr[data.index].selected) {
        this.checkedRowItemIdsArr[data.index].selected = true;
      }
      //when amount is blank then uncheck checkbox
      if (value.target.value == '') {
        this.checkedRowItemIdsArr[data.index].selected = false;
      }
      if(!this.updateBalance()){
        this.checkedRowItemIdsArr[data.index].selected = false;
        this.checkedRowItemIdsArr[data.index].amount = '';
        this.updateBalance()
      }
    },
    updateBalance() {
      let amount = parseInt(this.header[PAYMENT_FIELDS.AMOUNT]) + this.totalVendorCredit;
      this.totalPayment = this.totalCredit = 0;
      this.checkedRowItemIdsArr.map(data => {
        if (data.selected && data.amount > 0) {
          this.totalPayment += parseInt(data.amount);
        }
      });
      if (amount > 0) {
        this.totalCredit = amount - this.totalPayment;
          if(this.totalCredit<0){
            return false;
          }
      }
      return true;
    },
  },
  watch: {

  },
  async mounted() {
    if(this.$route.params.suggestion !== undefined && this.$route.params.suggestion.id !== undefined){
      console.log('this.route',this.$route.params);
      this.chosenName = this.$route.params.suggestion.name;
      this.onSuggestNameSelect(this.$route.params.suggestion);
      this.header[PAYMENT_FIELDS.AMOUNT] = this.$route.params.total;
    }

    await this.getChartOfAccounts(ACCOUNT_TYPES.Bank).then((result) => this.bankAccounts = result);
    await this.getChartOfAccounts(ACCOUNT_TYPES["Credit Card"]).then((result) => this.ccAccounts = result);
  },
  beforeDestroy() {
    this.selectCompany({});
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#purchaseOrders-header-nav {
  width: 100%;
  z-index: 1000;
  position: fixed;
  border-bottom: 1px solid rgb(200, 206, 211);
  background: #fff;
}

#purchaseOrders-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}

.purchaseOrders {
  &--purchaseOrders-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: left;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }
    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}

.amountTextBox {
  width: 95px;
}
</style>
